<template>
  <!-- 成功导入msg复用此结构 加class t-success -->
  <div>
    <OtherDialog
      @click-close="clickClose"
      @click-confirm="clickConfirm(arguments, popType)"
      :showMask="showMask"
      :dialogName="popType"
      :extra="dialogExtra"
    />
  </div>
</template>

<script>
import OtherDialog from '@/components/dialogs/index.vue';
export default {
  data() {
    return {
      showMask: true,
      popType: '',
      cancel: () => {},
      confirm: () => {},
      dialogExtra: {},
    };
  },
  components: {
    OtherDialog,
  },
  created() {},
  methods: {
    reset() {
      this.popType = '';
      this.cancel = () => {};
      this.confirm = () => {};
      this.showMask = false;
      this.dialogExtra = {};
    },
    clickClose() {
      this.cancel();
      this.reset();
    },
    clickConfirm(data) {
      this.confirm(data);
      this.reset();
    },
  },
};
</script>
